export default __webpack_public_path__ + "static/media/98c2d6ad8efaca9328a654a7fd1d8990.png";